export { XpmLogo, type TXpmLogoSize } from './XpmLogo';
